import { render, staticRenderFns } from "./CreateBPDefinition.vue?vue&type=template&id=1eb7fa88&"
import script from "./CreateBPDefinition.vue?vue&type=script&lang=js&"
export * from "./CreateBPDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports